export default "DETR et DSIL : dotations d'investissement local pour projets énergétiques des collectivités. Conditions, calendrier et articulation avec les primes CEE.";
